<app-cowatch *ngIf="openCoWatch" (onClose)="openCoWatch = false"></app-cowatch>
<video id="video" autoplay data-shaka-player playsinline></video>